import { Directive } from '@angular/core';
import { classes } from '@budgets/ui/helm/utils';

@Directive({
  selector: '[hlmAlertAction]',
  host: {
    'data-slot': 'alert-action',
  },
})
export class HlmAlertAction {
  constructor() {
    classes(() => 'absolute end-4 top-2.5');
  }
}
